import { driveFolderUrlFromDeal } from "@/lib/ops/driveDealFolder";

export function OpsDealDriveFolderLink(props: { deal: Record<string, unknown> }) {
  const url = driveFolderUrlFromDeal(props.deal);
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="text-xs text-indigo-600 underline-offset-2 hover:underline"
    >
      Open Drive folder
    </a>
  );
}
